import { Dayjs } from 'dayjs';
import { JobDashboardRange } from '../job-dashboard/job-dashboard-configuration';

export enum AggregationType {
  SUM = 'SUM',
  COUNT = 'COUNT',
  COUNT_DISTINCT = 'COUNT_DISTINCT',
  AVG = 'AVG',
  MIN = 'MIN',
  MAX = 'MAX',
}

export enum AnalyticsMetricType {
  AGGREGATE = 'AGGREGATE',
  BUCKETED_AVERAGE = 'BUCKETED_AVERAGE',
}

export enum ChartType {
  TABLE = 'TABLE',
  BAR_CHART = 'BAR_CHART',
  PIE_CHART = 'PIE_CHART',
}

export enum FilterOperator {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  CONTAINS = 'CONTAINS',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
}

export enum GroupingMode {
  NONE = 'NONE',
  FIELD = 'FIELD',
  DATE = 'DATE',
}

export enum DateGranularity {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export enum DateSourceType {
  JOB_LAST_UPDATED = 'JOB_LAST_UPDATED',
  RESULT_FIELD = 'RESULT_FIELD',
}

export enum EmptyBucketMode {
  INCLUDE_AS_ZERO = 'INCLUDE_AS_ZERO',
  ACTIVE_ONLY = 'ACTIVE_ONLY',
}

export interface AggregationField {
  fieldKey: string;
  type: AggregationType;
}

export interface ResultFieldFilter {
  fieldKey: string;
  operator: FilterOperator;
  value: string;
}

export interface DateGroupBy {
  granularity: DateGranularity;
  timezone?: string;
}

export interface BucketedAverageConfiguration {
  bucket: {
    granularity: DateGranularity;
  };
  timezone?: string;
  dateSource: {
    type: DateSourceType;
    fieldKey?: string;
  };
  value: {
    fieldKey: string;
    aggregation: AggregationType.COUNT_DISTINCT;
  };
  emptyBucketMode: EmptyBucketMode;
}

export interface JobResultAnalyticsDashboardConfiguration {
  title?: string;
  description?: string;
  dataConnectionIds?: string[];
  workerIds?: string[];
  statuses?: string[];
  range: JobDashboardRange;
  from?: Dayjs;
  to?: Dayjs;
  metricType?: AnalyticsMetricType;
  aggregations: AggregationField[];
  filters?: ResultFieldFilter[];
  groupingMode?: GroupingMode;
  groupBy?: string;
  dateGroupBy?: DateGroupBy;
  bucketedAverage?: BucketedAverageConfiguration;
  chartType: ChartType;
  limit?: number;
}

export const DEFAULT_JOB_RESULT_ANALYTICS_DASHBOARD_RANGE = JobDashboardRange.LAST_7_DAYS;

/** Maximum number of aggregation result groups. Must match backend MAX_AGGREGATION_RESULTS. */
export const MAX_AGGREGATION_RESULTS = 20;

/** Maximum aggregations per request. Must match backend MAX_AGGREGATIONS. */
export const MAX_AGGREGATIONS = 5;

/** Maximum filters per request. Must match backend MAX_FILTERS. */
export const MAX_FILTERS = 10;

/** Maximum date range in days. Must match backend MAX_DATE_RANGE_DAYS (91 to account for timezone edge cases). */
export const MAX_DATE_RANGE_DAYS = 91;
